<!-- デマンドの定期券は特別に予約するボタン -->
<template>
  <div class="footer before-use">
    <div class="buttons">
      <FaceStartButton @clicked="ncModeDemand()" buttonLabel="予約する" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ThePassLowerDemand",
  // TODO neModeDemand()をmixin→serviceに移行して使う
};
</script>

<style lang="scss"></style>
